<template>
  <v-container class="h-100 d-flex justify-center align-center">
    <div class="w-100">
      <v-row class="align-center justify-center" no-gutters>
        <v-col class="d-flex justify-center" cols="12" md="5">
          <div>
            <h1 class="white--text text-shadow-sm">
              สำนักแผนและพัฒนา <br />
              คุณภาพการศึกษา
            </h1>
            <v-btn
              href="https://qao.payap.ac.th"
              class="mt-3"
              color="primary"
              rounded
            >
              กลับหน้าหลัก
            </v-btn>
          </div>
        </v-col>
        <v-col class="d-flex justify-center" cols="12" md="6">
          <img :src="pixieImg" alt="Book pixie" />
        </v-col>
      </v-row>
      <v-row class="justify-center mt-6">
        <v-col v-for="(link, index) in links" :key="index" cols="12" md="2">
          <router-link :to="link.route" class="decoration-none">
            <v-card class="hydo" color="blue lighten-3">
              <v-card-text class="text-center white--text py-12">
                <v-icon color="white" x-large>{{ link.icon }}</v-icon>
                <h3 class="mt-4">{{ link.title }}</h3>
              </v-card-text>
            </v-card>
          </router-link>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      pixieImg: require("@/assets/image/book_pixie.svg"),
      links: [
        {
          icon: "fa-university",
          title: "ระดับมหาวิทยาลัย",
          route: {
            name: "Assurance",
            query: { level: "institution" }
          },
        },
        {
          icon: "fa-building",
          title: "ระดับคณะ",
          route: {
            name: "Assurance",
            query: { level: "faculty" }
          },
        },
        {
          icon: "fa-book",
          title: "ระดับหลักสูตร",
          route: {
            name: "Assurance",
            query: { level: "course" }
          },
        },
      ],
    }
  },
}
</script>

<style scoped>
.pixie-content {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 1200px;
}

img {
  width: 100%;
  max-width: 500px;
}
</style>